import { formatDisplayPrice } from '../utils/pipe-utils';

export enum SubscriptionLevel {
  LITE = 0,
  BASIC = 1,
}

export class Partner {
  name: string;
  partner_id: string;
  partner_is_sso: boolean;
  formatted_ld_wholesale_price: string;
  pb_is_always_enabled_flag: boolean;
  ld_is_enabled: boolean;
  subscription_level: SubscriptionLevel;

  constructor(data: any) {
    Object.assign(this, data);

    this.partner_id = data.pid;
    this.partner_is_sso = !data.has_vbc_flag;

    if (data.ld_wholesale_price) {
      this.formatted_ld_wholesale_price = formatDisplayPrice(data.ld_wholesale_price, null, null, true);
    }

    switch (data.subscription_level) {
      case 'LITE':
        this.subscription_level = SubscriptionLevel.LITE;
        break;
      case 'BASIC':
        this.subscription_level = SubscriptionLevel.BASIC;
        break;
    }
  }
}
